module.exports = __webpack_public_path__ + "static/media/valores-sendero.1a8cd5b8.svg";